var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaleIconBw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 57,
    viewBox: "0 0 24 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    },
    clipPath: "url(#clip0_115_4190)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.38501 44.1697V57.0004",
    stroke: "#FBC809",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9436 44.1697C19.9436 42.789 18.8243 41.6697 17.4436 41.6697C16.0629 41.6697 14.9436 42.789 14.9436 44.1697H19.9436ZM14.9436 44.1697V57.0004H19.9436V44.1697H14.9436Z",
    fill: "#FBC809"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.7666 42.7766V24.9806C2.7666 20.3514 6.86361 16.5989 11.9177 16.5989C16.9718 16.5989 21.0688 20.3514 21.0688 24.9806V42.7766H2.7666Z",
    stroke: "#00B5E2",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1315 14.3287C20.0114 11.6909 20.0114 7.41411 17.1315 4.77628C14.2515 2.13845 9.58216 2.13845 6.70219 4.77628C3.82222 7.41411 3.82222 11.6909 6.70219 14.3287C9.58216 16.9665 14.2515 16.9665 17.1315 14.3287Z",
    stroke: "#00B5E2",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_115_4190"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 57.0004,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaleIconBw);
export default __webpack_public_path__ + "static/media/MaleIconBW.373162a08ea3013ceb40420ac3b70ed1.svg";
export { ForwardRef as ReactComponent };